'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _queryString = require('query-string');

var _queryString2 = _interopRequireDefault(_queryString);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _config = require('../config.json');

var _config2 = _interopRequireDefault(_config);

var _noperm = require('./noperm');

var _noperm2 = _interopRequireDefault(_noperm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _axios2.default.create({
  baseURL: _config2.default.API_URL,
  withCredentials: false
});

// 兼容旧版本代码

var instanceTest = _axios2.default.create({
  baseURL: _config2.default.TEST_API_URL,
  withCredentials: false
});

exports.default = {
  // 跳转登陆
  login: function login(_ref) {
    var _ref$project = _ref.project,
        project = _ref$project === undefined ? "" : _ref$project,
        _ref$url = _ref.url,
        url = _ref$url === undefined ? window.location.href : _ref$url,
        _ref$qa = _ref.qa,
        qa = _ref$qa === undefined ? false : _ref$qa,
        _ref$copyright = _ref.copyright,
        copyright = _ref$copyright === undefined ? (0, _stringify2.default)({
      guardian: "", // 维护人
      team: {
        name: "", // 开发组
        link: "" // 组介绍连接
      },
      feedback: "" // 反馈连接
    }) : _ref$copyright;

    var hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];
    _jsCookie2.default.remove(_config2.default.TOKEN_SCHEMA, {
      path: '/',
      domain: hostname === 'localhost' || /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/gim.test(hostname) ? hostname : '.' + hostname
    });
    if (!project) {
      _noperm2.default.login.apply(_noperm2.default, arguments);
      return;
    }
    // 存QA
    _jsCookie2.default.set(_config2.default.QA_SCHEMA, qa, {
      expires: _config2.default.TOKEN_EXPIRES,
      path: '/',
      domain: window.location.hostname
    });
    // 存project
    _jsCookie2.default.set(_config2.default.PROJECT_SCHEMA, project, {
      expires: _config2.default.TOKEN_EXPIRES,
      path: '/',
      domain: window.location.hostname
    });
    // 跳转登陆
    window.location.href = _config2.default.LOGIN_URL + '/perm?project=' + project + '&redirect_url=' + encodeURIComponent(url) + '&copyright=' + copyright + '&is_qa=' + (qa ? '1' : '0');
  },

  // 获取token
  getToken: function getToken() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$isPerm = _ref2.isPerm,
        isPerm = _ref2$isPerm === undefined ? false : _ref2$isPerm;

    if (!isPerm) {
      return _noperm2.default.getToken();
    }
    // cookie获取
    var hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];
    var token = _jsCookie2.default.get(_config2.default.TOKEN_SCHEMA, {
      path: '/',
      domain: hostname === 'localhost' || /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/gim.test(hostname) ? hostname : '.' + hostname
    });

    if (!token) {
      // url获取
      token = _queryString2.default.parse(window.location.search.slice(1)).token || '';
    }
    return token;
  },


  // 获取用户信息
  getUserInfo: function getUserInfo() {
    var _this = this;

    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$isPerm = _ref3.isPerm,
        isPerm = _ref3$isPerm === undefined ? false : _ref3$isPerm;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var tokenInCookie, tokenInUrl, token, hostname, queryList, url, isQa, api, res;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (isPerm) {
                _context.next = 2;
                break;
              }

              return _context.abrupt('return', _noperm2.default.getUserInfo());

            case 2:
              // cookie获取
              tokenInCookie = _jsCookie2.default.get(_config2.default.TOKEN_SCHEMA);
              // url获取

              tokenInUrl = _queryString2.default.parse(window.location.search.slice(1)).token;
              token = tokenInCookie || tokenInUrl;

              // 未获取到token返回null

              if (token) {
                _context.next = 7;
                break;
              }

              return _context.abrupt('return', null);

            case 7:

              if (Array.isArray(token)) {
                token = token[token.length - 1];
              }

              // cookie没有token，从url获取并保存
              if (!tokenInCookie && tokenInUrl) {
                hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];

                _jsCookie2.default.set(_config2.default.TOKEN_SCHEMA, token, {
                  path: '/',
                  expires: _config2.default.TOKEN_EXPIRES,
                  domain: hostname === 'localhost' || /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/gim.test(hostname) ? hostname : '.' + hostname
                });
              }
              if (tokenInUrl) {
                queryList = _queryString2.default.parse(window.location.search.slice(1));

                delete queryList.token;
                url = window.location.href.replace(window.location.search.slice(1), _queryString2.default.stringify(queryList));

                window.location.replace(url);
              }
              // 获取用户信息
              isQa = _jsCookie2.default.get(_config2.default.QA_SCHEMA);
              api = isQa && isQa === 'true' ? instanceTest : instance;
              _context.next = 14;
              return api.get('/member/getMember', {
                params: {
                  project: _jsCookie2.default.get(_config2.default.PROJECT_SCHEMA),
                  token: token
                }
              });

            case 14:
              res = _context.sent;

              if (!(res.status === 200 && !res.data.code && res.data.data && res.data.data.member)) {
                _context.next = 19;
                break;
              }

              return _context.abrupt('return', res.data.data.member);

            case 19:
              return _context.abrupt('return', null);

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  // 登出
  logout: function logout() {
    var _this2 = this;

    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$isPerm = _ref4.isPerm,
        isPerm = _ref4$isPerm === undefined ? false : _ref4$isPerm;

    return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
      var token, hostname, queryList, url;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (isPerm) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return', _noperm2.default.logout());

            case 2:
              token = exports.default.getToken({ isPerm: isPerm });


              if (token) {
                _jsCookie2.default.remove(_config2.default.PROJECT_SCHEMA, {
                  path: '/',
                  domain: window.location.hostname
                });
                hostname = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim.exec(window.location)[1];

                _jsCookie2.default.remove(_config2.default.TOKEN_SCHEMA, {
                  path: '/',
                  domain: hostname === 'localhost' || /\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.|$)){4}\b/gim.test(hostname) ? hostname : '.' + hostname
                });
                _jsCookie2.default.remove(_config2.default.QA_SCHEMA, {
                  path: '/',
                  domain: window.location.hostname
                });

                queryList = _queryString2.default.parse(window.location.search.slice(1));

                if (!!queryList.token) {
                  delete queryList.token;
                  url = window.location.href.replace(window.location.search.slice(1), _queryString2.default.stringify(queryList));

                  window.location.replace(url);
                } else {
                  window.location.reload();
                }
              }
              return _context2.abrupt('return', true);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@qtt/ewx-login-sdk/lib/index.js
// module id = 65
// module chunks = 15